import { WidgetEvent } from './widgetEvents';

export const SIGNABLE_EVENT_NAMES = [
  WidgetEvent.EmailPrechecked,
  WidgetEvent.EmailPrecheckLogin,
  WidgetEvent.EmailVerificationStatus,
  WidgetEvent.SMSVerificationBypass,
  WidgetEvent.SMSVerification,
  WidgetEvent.SMSVerificationStatus,
  WidgetEvent.ProcessFinished,
  WidgetEvent.TechnicalError,
] as const;
